import { encodePaginatableQuery, PaginatableQuery, Query } from '@/services/api';
import * as q from '@/services/api/request/query';

export interface ListIssueTemplateQuery extends PaginatableQuery {
  checklist?: Array<number>;
}

export const encodeListIssueTemplateQuery = (query: ListIssueTemplateQuery): Query => ({
  ...encodePaginatableQuery(query),
  checklist: q.numbers(query.checklist ?? []),
});
